<div class="stepper">
  <div
    *ngFor="let step of steps; let stepNumber = index"
    class="stepper__item"
    [ngClass]="{
      'stepper__item--before': ((stepNumber + 1) < currentStep),
      'stepper__item--current': ((stepNumber + 1) === currentStep),
      'stepper__item--after': ((stepNumber + 1) > currentStep)
    }"
    (click)="navigateToStep(((stepNumber + 1) < currentStep), (stepNumber + 1), step.callback)"
  >
    <div class="item__number">{{ stepNumber + 1 }}</div>
    <div class="item__container">
      <h4 class="item__title">{{ step.title | translate }}</h4>
      <p class="item__description">{{ step.description || '' | translate }}</p>
    </div>
  </div>
</div>
